"use client";
import { Box, Container, Typography, Avatar } from "@mui/material";
import Image from "next/image";

export default function SpacePageContent({ spaceData }) {
  return (
    <Container
      maxWidth="lg"
      sx={{
        minHeight: "100vh",
        py: 4,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: 3,
        }}
      >
        {/* Space Logo */}
        {spaceData?.logoIcon?.url && (
          <Box
            sx={{
              width: 120,
              height: 120,
              position: "relative",
              borderRadius: "50%",
              overflow: "hidden",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <Image
              src={spaceData.logoIcon.url}
              alt={spaceData?.name || "Space logo"}
              fill
              style={{ objectFit: "cover" }}
            />
          </Box>
        )}

        {/* Space Name */}
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "2rem", md: "2.5rem" },
            color: "#1a1a1a",
          }}
        >
          {spaceData?.name}
        </Typography>

        {/* Space Description */}
        {spaceData?.description && (
          <Typography
            variant="body1"
            sx={{
              maxWidth: "800px",
              fontSize: "1.1rem",
              color: "#5C677D",
              lineHeight: 1.8,
            }}
          >
            {spaceData.description}
          </Typography>
        )}

        {/* Additional Information */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            mt: 4,
            width: "100%",
            maxWidth: "600px",
          }}
        >
          {spaceData?.address && (
            <Box sx={{ textAlign: "left" }}>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, color: "#1a1a1a", mb: 0.5 }}
              >
                Address
              </Typography>
              <Typography variant="body2" sx={{ color: "#5C677D" }}>
                {spaceData.address}
              </Typography>
            </Box>
          )}

          {spaceData?.phone && (
            <Box sx={{ textAlign: "left" }}>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, color: "#1a1a1a", mb: 0.5 }}
              >
                Phone
              </Typography>
              <Typography variant="body2" sx={{ color: "#5C677D" }}>
                {spaceData.phone}
              </Typography>
            </Box>
          )}

          {spaceData?.email && (
            <Box sx={{ textAlign: "left" }}>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, color: "#1a1a1a", mb: 0.5 }}
              >
                Email
              </Typography>
              <Typography variant="body2" sx={{ color: "#5C677D" }}>
                {spaceData.email}
              </Typography>
            </Box>
          )}

          {spaceData?.website && (
            <Box sx={{ textAlign: "left" }}>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, color: "#1a1a1a", mb: 0.5 }}
              >
                Website
              </Typography>
              <Typography
                variant="body2"
                component="a"
                href={spaceData.website}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "#2A82F6",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {spaceData.website}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Container>
  );
}
